export const Constantes = {
  HOST_WINGS: window._env_.REACT_APP_HOST_WINGS,
  HOST_ASSETS: window._env_.REACT_APP_HOST_ASSETS,
  HOST_HEFESTO: window._env_.REACT_APP_HOST_HEFESTO,
  HOST_CONFIGURACAO: window._env_.REACT_APP_HOST_CONFIGURACAO,
};
